<template>
    <div>
        <div v-if="!dispForm && clientSiteRedirecting" class="redirectingCover">
            <transition name="fade">
                <div class="text-center pr-2 pl-2 pt-5">
                    <p class="text-nowrap" v-html="$t('auth.clientSiteRedirecting.' + clientName)"></p>
                </div>
            </transition>
        </div>
        <div v-else-if="!dispForm && memberError" class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin py-5 py-md-3">
            <div class="is-invalid"></div>
                <div class="invalid-feedback">{{ $t('errors.' + memberError + '.' + clientName) }}    
            </div>
        </div>
        <div v-else-if="dispForm" class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div v-if="errors.redirectUrl"  class="form-group py-5 py-md-3">
                <div class="is-invalid"></div>
                <div class="invalid-feedback">{{ $t('errors.' + errors.redirectUrl) }}</div>
            </div>
            <div v-else>
                <div class="text-center p-2">
                    <h3>{{ $t('auth.login') }}</h3>
                </div>

                <div class="text-center p-2">
                    <p v-if="isClientLogin()" class="text-nowrap" v-html="$t('auth.client.' + clientName)"></p>
                </div>
                <div v-if="errors.is_suspended" class="text-center p-2">
                    <p class="text-danger font-weight-bold">{{ $t('errors.' + errors.is_suspended) }}</p>
                </div>

                <div class="tab-content p-2">
                    <div class="tab-pane fade show active" id="tab-login" role="tabpanel"
                        aria-labelledby="pills-login-tab">
                        <form @submit.prevent="handleOnSubmit">
                            <div class="form-group">
                                <label for="account">{{ $t('account.email') }}</label>
                                <input v-model="formData.account" name="account" id="account" class="form-control"
                                    v-bind:class="{ 'is-invalid': errors.account}" maxlength="255">
                                <div v-if="errors.account" class="invalid-feedback">{{ $t('errors.' + errors.account) }}</div>
                            </div>

                            <div class="form-group">
                                <label for="password">{{ $t('account.edit.password') }}</label>
                                <input v-model="formData.password" type="password" id="password" name="password" class="form-control"
                                    v-bind:class="{ 'is-invalid': errors.password}"/>
                                <div v-if="errors.password" class="invalid-feedback">{{ $t('errors.' + errors.password) }}</div>
                            </div>

                            <div class="form-check">
                                <input v-model="formData.member" name="member" type="checkbox"
                                    class="form-check-input" id="member">
                                <label class="form-check-label-login" for="member">
                                    {{ $t('auth.remember') }}
                                </label>
                            </div>

                            <div v-if="errors.recaptchaToken"  class="form-group">
                                <div class="is-invalid"></div>
                                <div class="invalid-feedback">{{ $t('errors.' + errors.recaptchaToken) }}</div>
                            </div>

                            <div v-if="memberError"  class="form-group">
                                <div class="is-invalid"></div>
                                <div class="invalid-feedback">{{ $t('errors.' + memberError + '.' + clientName) }}</div>
                            </div>

                            <div class="text-center p-2">
                                <button type="submit"  :disabled="submitBtnDisabled()" class="btn btn-primary">{{ $t('auth.login') }}</button>
                            </div>

                            <div class="text-center p-2">
                                <router-link to="/forgot-password">{{ $t('account.password.forgot') }}</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import UserService from '../../services/UserService';
    import languageService from '../../services/LanguageService';
    import RecaptchaMixin from '../../utils/RecaptchaMixin';
    
    export default {
        name: 'login-module',
        mixins: [RecaptchaMixin],

        components: {

        },

        async mounted() {
            // パラメータのリダイレクト先URLを取得する
            this.formData.redirectUrl = this.$route.query.redirect_url

            // クライアントログインの場合
            if (this.isClientLogin()) {
                // リダイレクト先URL（認証クライアント）のチェック
                try {
                    const result =  
                        await UserService.getClientName(
                            this.formData.redirectUrl
                        );
                    this.clientName = result.data.clientName;
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            this.errors[error.field] = error.message[0];
                        }
                    });
                }
                // 自動ログインの場合
                if (!this.errors.redirectUrl && AuthUtil.isAuth()) {
                    try {
                        const result =  
                            await UserService.clientAutoLogin(
                                this.formData.redirectUrl,
                                AuthUtil.getAuthToken()
                            );
                        this.clientOnetimeToken = result.data.onetimeToken;
                        this.redirectToClientUrl()
                    } catch (error) {
                        error.response.data.errors.forEach(error => {
                            if (error.field) {
                                this.errors[error.field] = error.message[0];
                            }
                            if (error.field === 'advance') {
                                this.memberError = error.message[0];
                            }
                            if (error.field === 'advanceAndBasic') {
                                this.memberError = error.message[0];
                            }
                        });
                    }
                // 自動ログインではない or リダイレクト先URLが不正な場合
                } else {
                    this.dispForm = true;
                }
            // 通常のログイン画面への遷移（ログイン中）
            } else if (AuthUtil.isAuth()) {
                this.$router.push('/');
            // 通常のログイン画面への遷移
            } else {
                this.dispForm = true;
            }
        },

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                clientName: null,
                clientOnetimeToken: null,
                dispForm: false,
                clientSiteRedirecting: false,
                memberError: '',
                loginData: null,
            }
        },

        methods: {
            getDefaultFields() {
                return {
                    account: '',
                    password: '',
                    member: false,
                    member_type: '',
                    is_suspended: '',
                    recaptchaToken: '',
                    redirectUrl: ''
                }
            },

            submitBtnDisabled() {
                return false;
            },

            async handleOnSubmit(e) {
                this.sessionOrderClear();
                this.session2saClear();

                this.errors = this.getDefaultFields();
                this.language = languageService.getCurrentLanguageCode();
                const recaptchaToken = await this.recaptchaGetKey();

                try {
                    // ログイン処理をリクエストしているが、会員資格停止中のユーザーにも例外が返される
                    const result = this.isClientLogin() ? 
                        await UserService.clientLogin(
                            this.formData.account,
                            this.formData.password,
                            this.formData.member,
                            this.language,
                            recaptchaToken,
                            this.formData.redirectUrl
                        )
                        :
                        await UserService.login(
                            this.formData.account,
                            this.formData.password,
                            this.formData.member,
                            this.language,
                            recaptchaToken
                        );

                    // 2段階認証が有効の場合は、ログインを完了せずに2段階認証画面へ
                    if (result.data.google2saActive) {
                        this.loginData = result.data;
                        this.setSession2sa();
                        this.$router.push('/login/2sa');
                        return;
                    }

                    UserService.setLogin(this.isClientLogin() ? result.data.aube : result.data);
                    const user = (await UserService.getUserFrontendData(true)).data;

                    this.member_type =  user.member_type_id;

                    if (this.isClientLogin()) {
                        // クライアントログインの場合はリダイレクト先URLへ遷移する
                        this.clientOnetimeToken = result.data.client.onetimeToken;
                        this.redirectToClientUrl()
                    } else if (user.is_child && !user.changed_password) {
                        this.$router.push('/child/change-password');
                    } else {
                        if (!user.is_child) {
                            this.$router.push('/');
                        } else {
                            this.$router.push('/studies-top');
                        }
                    }
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            this.errors[error.field] = error.message[0];
                        }
                        if (error.field === 'advance') {
                            this.memberError = error.message[0];
                        }
                        if (error.field === 'advanceAndBasic') {
                            this.memberError = error.message[0];
                        }
                    });
                }
            },

            isClientLogin() {
                return !!this.formData.redirectUrl
            },

            async redirectToClientUrl() {
                this.clientSiteRedirecting = true;
                if (this.clientRedirectQuery()) {
                    window.location.replace(this.formData.redirectUrl + "?" + this.clientRedirectQuery());
                } else {
                    window.location.replace(this.formData.redirectUrl);
                }
            },

            clientRedirectQuery() {
                // リダイレクト時に渡すクエリストリングを返す
                return Object
                        .keys(this.$route.query)
                        .filter(key => key !== "redirect_url")
                        .map(key => key + "=" + this.$route.query[key])
                        .concat(['token=' + this.clientOnetimeToken])
                        .join('&');
            },

            sessionOrderClear() {
                sessionStorage.removeItem('amount');
                sessionStorage.removeItem('copy');
                sessionStorage.removeItem('length');
                sessionStorage.removeItem('order_address_1');
                sessionStorage.removeItem('order_address_2');
                sessionStorage.removeItem('order_company_name');
                sessionStorage.removeItem('order_forwarding_address_1');
                sessionStorage.removeItem('order_forwarding_address_2');
                sessionStorage.removeItem('order_forwarding_company_name');
                sessionStorage.removeItem('order_forwarding_name');
                sessionStorage.removeItem('order_forwarding_phone_number');
                sessionStorage.removeItem('order_forwarding_post_number_1');
                sessionStorage.removeItem('order_forwarding_post_number_2');
                sessionStorage.removeItem('order_name');
                sessionStorage.removeItem('order_phone_number');
                sessionStorage.removeItem('order_post_number_1');
                sessionStorage.removeItem('order_post_number_2');
                sessionStorage.removeItem('price');
                sessionStorage.removeItem('privacy_policy');
                sessionStorage.removeItem('tax');
                sessionStorage.removeItem('total');
            },

            session2saClear() {
                sessionStorage.removeItem('redirectUrl');
                sessionStorage.removeItem('loginData');
                sessionStorage.removeItem('queryString');
            },

            setSession2sa() {
                if (this.formData.redirectUrl) {
                    sessionStorage.redirectUrl = this.formData.redirectUrl;
                } else {
                    sessionStorage.removeItem('redirectUrl');
                }
                sessionStorage.loginData = JSON.stringify(this.loginData);
                
                sessionStorage.queryString = Object.keys(this.$route.query)
                                                    .filter(key => key !== "redirect_url")
                                                    .map(key => key + "=" + this.$route.query[key])
                                                    .join('&');
            }
        }
    }
</script>

<style scoped>
    .form-check-label-login{
        margin-bottom: 0;
        white-space: nowrap;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
</style>

<style lang="scss">
    .redirectingCover {
        background-color: rgb(255, 255, 255, 0.75);
        min-width: 100%;
        min-height: 100%;
        position: fixed;
        top: 0;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -15px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
